$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.player').directive('toastArea', (function($rootScope, $timeout) {
    return {
      template: '<div class="toast" ng-class="{invisible: !toast}">{{ toast }}</div>',
      link: (function($scope, elem) {
        $rootScope.$on('toast', (function(sender, message) {
          $scope.toast = message;
          $timeout((function() {
            return $scope.toast = null;
          }), 3000);
        }));
      })
    };
  })).factory('Toast', (function($rootScope) {
    return (function(message) {
      return $rootScope.$broadcast('toast', message);
    });
  })).directive('animatedInputLabel', (function($rootScope, $timeout) {
    return {
      restrict: 'A',
      link: (function($scope, $elem) {
        $elem = $($elem);
        var val = $elem.val();
        if (val) {
          $elem.siblings('.label').addClass('is-moved');
        } else {
          $elem.siblings('.label').removeClass('is-moved');
        }
        $elem.on('focus', (function(e) {
          e.preventDefault();
          $elem.siblings('.label').addClass('is-moved');
        }));
        $elem.on('blur', (function(e) {
          e.preventDefault();
          if (!$elem.val()) {
            $elem.siblings('.label').removeClass('is-moved');
          }
        }));
      })
    };
  })).directive('fancybox', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        $(element).fancybox({
          type: 'iframe',
          scrolling: 'no',
          maxWidth: 1280,
          maxHeight: 600,
          fitToView: true,
          width: '90%',
          height: '90%',
          autoSize: false,
          closeClick: true,
          padding: 0,
          openEffect: 'elastic',
          closeEffect: 'elastic',
          helpers: {
            media: {vimeo: {params: {
                  autoplay: 1,
                  rel: 0,
                  controls: 0,
                  showinfo: 0,
                  autohide: 1
                }}},
            buttons: {}
          },
          beforeShow: function() {
            var id = $.fancybox.inner.find('iframe').attr('id');
            var player = new Vimeo.Player(id);
            player.on('ended', function(data) {
              $.fancybox.close();
            });
          }
        });
      }
    };
  });
  ;
  return {};
});

